<!-- eslint-disable vue/no-parsing-error -->
<template>
    <b-card>

        <FormInput id="title" label="Title" v-model="formPayload.title" :modelValue="formPayload.title"
            :validation="validations.title" placeholder="Title" :required="true" />

        <b-form-group v-if="userData.role == 'admin'">
            <label for="partner">Partner: <span class="text-danger">*</span></label>
            <v-select id="partner" v-model="formPayload.partner" :options="options.partner" :reduce="item => item.uuid"
                label="name" placeholder="Type to search Partner..." @search="onSearchPartner">
                <template slot="no-options">
                    Type here to search partner...
                </template>
            </v-select>
        </b-form-group>

        <b-form-group>
            <label for="content_type">Content: <span class="text-danger">*</span></label>
            <quill-editor id="content" v-model="formPayload.content" :options="editorOption" ref="quillEdit"
                @ready="onEditorReady">
                <div id="toolbar" slot="toolbar" />
            </quill-editor>
            <small v-if="validations.hasOwnProperty('content') && validations.content.length > 0" class="text-danger">
                {{ validations.content.join(', ') }}
            </small>
        </b-form-group>

        <template>
            <div v-if="isLoading" class="mb-1">
                <b-spinner class="mb-2" variant="primary" /><br>
            </div>
            <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
                Save Item
            </b-button>
            <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
                Save Item
            </b-button>
        </template>
    </b-card>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BSpinner, BPagination, BFormInput, BFormGroup, BFormCheckbox, BFormSpinbutton
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import FormInput from '@/components/FormInput.vue'
import FormSelect from '@/components/FormSelect.vue'
import FormVueSelect from '@/components/FormVueSelect.vue'
import vSelect from 'vue-select'


import { quillEditor, Quill } from 'vue-quill-editor'
import YoutubeBlob from '@/utils/YoutubeBlob'
Quill.register(YoutubeBlob)


export default {
    title() {
        return 'Detail Pages Management'
    },
    components: {
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BSpinner,
        BPagination,
        BFormInput,
        FormInput,
        FormSelect,
        FormVueSelect,
        vSelect,
        BFormGroup,
        BFormCheckbox,
        BFormSpinbutton,
        quillEditor
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,

            options: {
                partner: []
            },

            result: Object,
            isLoading: false,
            formPayload: {
                title: '',
                content: '',
                partner: '',
            },
            editId: null,
            validations: {},

            editorOption: {
                theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            ['link', 'image', 'video', 'formula'],

                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],

                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean']
                        ],
                        handlers: {
                            image: this.imageHandler, // Custom image handler
                            video: this.videoHandler, // Custom video handler
                        },
                    },
                },
            },
        }
    },
    mounted() {
        this.getData()
        this.getPartner()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        onEditorReady(editor) {
            // Keep a reference to the editor instance
            this.quill = editor;
        },
        imageHandler() {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();

            input.onchange = async () => {
                const file = input.files[0];
                if (file) {
                    /**
                     * Upload file to Server
                     */
                    const fileUploadPayload = new FormData();
                    fileUploadPayload.append('file', file);
                    try {
                        const uploadToServer = await this.$http.post("/admin/upload-files", fileUploadPayload, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        const uploadToServerResponse = uploadToServer.data.data.file_url;
                        const range = this.quill.getSelection();
                        setTimeout(() => {
                            console.log('set image');
                            this.quill.insertEmbed(range.index, 'image', uploadToServerResponse);
                        }, 3000);
                    } catch (error) {
                        console.log('Error quiil upload image :', error);
                        errorNotification(this, `Upload file ${file.name} error`);
                    }
                }
            };
        },
        videoHandler() {
            const url = prompt('Enter Video/Audio URL (YouTube or Spotify)')
            if (url) {
                let embedUrl = url
                
                // YouTube
                const videoIdMatch = url.match(/(?:\?v=|\/embed\/|\.be\/)([^&?]+)/)
                if (videoIdMatch) {
                    embedUrl = 'https://www.youtube.com/embed/' + videoIdMatch[1]
                } 
                // Spotify
                else if (url.includes('open.spotify.com')) {
                    // Convert https://open.spotify.com/track/ID to https://open.spotify.com/embed/track/ID
                    // Also handles album, playlist, artist etc.
                    embedUrl = url.replace('open.spotify.com', 'open.spotify.com/embed')
                }

                // If selection is null, focus the editor first
                if (!this.quill.getSelection()) {
                    this.quill.focus()
                }

                // Get selection range; if null (still), default to 0 (start of doc) or length
                const range = this.quill.getSelection() || { index: this.quill.getLength() }
                
                this.quill.insertEmbed(range.index, 'video', embedUrl)
            }
        },
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.partner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.partner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                title: '',
                content: '',
                partner: '',
            }
        },
        getData() {
            if (this.$route.params.id) {
                this.$http.get(`admin/pages/${this.$route.params.id}`).then((result) => {
                    const { title, partner, content } = result.data.data
                    this.editId = this.$route.params.id

                    this.formPayload = {
                        title: title,
                        content: content,
                        partner: partner._id,
                    }
                }).catch((err) => {

                });
            }
        },
        createItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.post('/admin/pages', form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    successNotification(this, 'Success', 'Page successfully created')
                    this.cleanUpForm()
                    this.$router.push({ name: 'pages' })
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.patch(`/admin/pages/${this.editId}`, form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.getData()
                    successNotification(this, 'Success', 'Page successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    form.append(key, this.formPayload[key])
                }
            }

            return form
        },
        editItem(item) {
            this.editId = item._id
            this.formPayload = {
                title: item.title,
                content: item.content,
                partner: item.partner._id,
            }
        },
    },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
@import '@core/scss/vue/libs/vue-select.scss';

.ql-container {
    height: calc(100svh - 40rem);
}
</style>
